export const menuItemsData = [
  {
    title: "Главная",
    url: "/",
  },

  {
    title: "О компании",
    submenu: [
      {
        title: "О компании",
        url: "o-kompanii",
      },

      {
        title: "Учредительные документы и свидетельства",
        url: "dokumenty",
      },
      {
        title: "Платежные реквизиты",
        url: "dokumenty",
      },
    ],
  },

  {
    title: "Жителям",
    submenu: [
      {
        title: "Информация для населения",
        submenu: [
          {
            title: "График готовности к отопительному периоду",
            url: "informatsiya-dlya-naseleniya",
          },
          {
            title: "График ремонта и обслуживания котельных",
            url: "informatsiya-dlya-naseleniya",
          },
          {
            title: "План текущего ремонта",
            url: "informatsiya-dlya-naseleniya",
          },
          {
            title: "График технического обслуживания газового оборудования",
            url: "informatsiya-dlya-naseleniya",
          },
          {
            title: "График испытания систем отопления",
            url: "informatsiya-dlya-naseleniya",
          },
          {
            title: "Платные услуги",
            url: "informatsiya-dlya-naseleniya",
          },

        ],
      },



      {
        title: "Раскрытие информации",
        submenu: [
          {
            title: "Финансовая отчетность",
            url: "otchyotnost",
          },
          {
            title: "Привлечение к ответственности",
            url: "privlecheniye-k-otvetstvennosti",
          },
        ], 
      },

  {
    title: "Информация по объектам",
    submenu: [
      {
        title: "Дома в управлении и договора",
        url: "doma-v-upravlenii",
      },
      {
        title: "Собрания собственников",
        url: "sobraniya-sobstvennikov",
      },
    ],
  },

  {
    title: "Тарифы на ЖКХ",
    url: "tarify-na-zhkh",
  },

  {
    title: "Ресурсоснабжающие организации",
    url: "resursosnabzhaushchiye-organizacii",
  },

    ], 
  },




  {
    title: "Новости",
    url: "/novosti",
  },

  {
    title: "Контакты",
    url: "/kontakty",
  },
];